export default __webpack_public_path__ + "static/media/GOVERNMENT_EDUCATION.7f6f7732.png";